module.exports = __webpack_public_path__ + "static/media/Movie.9d2e7cb2.png";